import { useEffect, useState } from 'react'

import Api from 'services/api'
import { RoleFeature } from 'types/RoleFeature'

const useRoleFeatures = () => {
  const [roleFeatures, setRoleFeatures] = useState<Array<RoleFeature> | null>(null)
  const [isRoleFeaturesLoaded, setIsRoleFeaturesLoaded] = useState(false)

  useEffect(() => {
    Api.FeatureCodes.roleFeatures()
      .then(res => {
        setRoleFeatures(res)
      }).catch(() => {
        setRoleFeatures(null)
      })
      .finally(() => setIsRoleFeaturesLoaded(true))
  }, [])

  return { roleFeatures, isRoleFeaturesLoaded }
}

export default useRoleFeatures
